import * as React from "react";

import { NaarWaarheidIngevuldContextProvider } from "@cak-legacy/btl-forms";
import {
  I18nService,
  removeStylingLinksFromDifferentPilets,
  setOpenExternLinkHandlers,
  useMutationObserver
} from "@cak-legacy/i18n-iprox";
import { formulierPageContainerClassName, PiletLoader } from "@klantondersteuning-btl/shared";

import { IAanvraagDocumentS1GezinsledenComponentProps } from "../components/AanvraagDocumentS1GezinsledenComponent";
import { i18n, initialize } from "../i18n";

import "@cak-legacy/shared-design/scss/css-icons.scss";

const AanvraagDocumentS1GezinsledenComponent = React.lazy(
  () => import("../components/AanvraagDocumentS1GezinsledenComponent")
);

export type IAanvraagDocumentS1GezinsledenPageProps = IAanvraagDocumentS1GezinsledenComponentProps;

export const AanvraagDocumentS1GezinsledenPage = (props: IAanvraagDocumentS1GezinsledenPageProps) => {
  React.useLayoutEffect(
    () => removeStylingLinksFromDifferentPilets("opencak-btl-klantondersteuning", "opencak"),
    []
  );

  useMutationObserver(() => setOpenExternLinkHandlers());

  React.useEffect(() => {
    const i18nService = new I18nService(props.apiGatewayUrl);
    initialize(i18n, {
      language: props.language,
      resolve: (namespace, language) => i18nService.getTranslations(namespace, language)
    });
  }, [props.apiGatewayUrl, props.language]);

  return (
    <div>
      <React.Suspense fallback={<PiletLoader />}>
        <NaarWaarheidIngevuldContextProvider>
          <div className="formulier-page-container-stepper-form">
            <div className={formulierPageContainerClassName}>
              <AanvraagDocumentS1GezinsledenComponent {...props} />
            </div>
          </div>
        </NaarWaarheidIngevuldContextProvider>
      </React.Suspense>
    </div>
  );
};
